/**
 * A/B-Loop status banner.
 *
 * States:
 *   none       — banner hidden
 *   markerSet  — single B pressed; shows "Loop-Marker bei <t>"
 *   looping    — A→B confirmed; shows times + "Region speichern" button
 */
import { fmtTime } from '../core/utils.js';

export function createBanner() {
  const el = document.createElement('div');
  el.className = 'zap-pe-banner';
  el.hidden = true;
  return el;
}

export function renderBanner(banner, loop, onConvert) {
  if (loop.loopState === 'none') {
    banner.hidden = true;
    return;
  }
  banner.hidden = false;
  if (loop.loopState === 'markerSet') {
    banner.classList.remove('is-active');
    banner.innerHTML =
      '🔖 Loop-Marker bei <strong>' + fmtTime(loop.loopStart) + '</strong> · '
      + '<kbd>Leertaste</kbd> hier loopen, <kbd>B</kbd> reset';
    return;
  }
  // looping
  banner.classList.add('is-active');
  banner.innerHTML =
    '🔁 A→B  <strong>' + fmtTime(loop.loopStart) + '</strong> → '
    + '<strong>' + fmtTime(loop.loopEnd) + '</strong>'
    + ' <button data-act="convert">⏭ Region speichern</button>'
    + ' <kbd>Leertaste</kbd> Loop aus';
  banner.querySelector('[data-act="convert"]')?.addEventListener('click', (ev) => {
    ev.stopPropagation();
    onConvert();
  });
}
